import React from "react";
import { useNavigate } from "react-router-dom";

function ReceiptWalletFront({ stateChanger, data, save, state, otherColors }) {
  const navigate = useNavigate();
  return (
    <>
      <div className=" flex flex-col justify-center gap-5">
        <h2 className="text-[24px]" style={{ fontFamily: "ZapfHumanistBold" }}>
          RECEIPT WALLET (COVER)
        </h2>
        <div className="text-[14px]">
          <p>
            Add a touch of class to your sales by providing your customers with
            a quality wallet for their receipt. You can provide a brief
            information about your store and values on the inside and your
            contact details on the reverse. We produce these at A6(105x148mm),
            CMYK print, 350gsm with soft touch matt lamination to both sides.
            <p style={{ fontFamily: "ZapfHumanistBold" }}>
              If you prefer to have a product or lifestyle image on the cover,
              we can assist you after the customisation steps.
            </p>
          </p>
        </div>
        {/* <div className="flex px-10"> */}

        <p
          className="text-[14px] mt-10"
          style={{ fontFamily: "ZapfHumanistBold" }}
        >
          Type your store web address here:
        </p>
        <input
          className="rounded-md w-[80%] h-[40px] p-4 text-[14px]"
          type="text"
          id="text"
          name="text"
          placeholder="Enter your website URL (www...)"
          defaultValue={data.urlLink}
          maxLength={35}
          required
          onChange={(e) => {
            stateChanger("urlLink", e.target.value);
          }}
        />

        {/* </div> */}
        <div className="flex gap-2">
          <button
            style={{ fontFamily: "ZapfHumanistBold" }}
            className="bg-red-500 hover:bg-[#02595A] text-white px-3 py-2 mt-8 rounded-full text-[18px] w-[165px] focus:border border-[#0F0F0F] border-solid transition-transform duration-300 hover:scale-110"
            onClick={save}
          >
            SAVE PROGRESS
          </button>
          <button
            style={{ fontFamily: "ZapfHumanistBold" }}
            className="bg-red-500 hover:bg-[#02595A] text-white px-3 py-2 mt-8 rounded-full text-[18px] w-[165px] focus:border border-[#0F0F0F] border-solid transition-transform duration-300 hover:scale-110"
            onClick={() => {
              navigate("/form", { state });
            }}
          >
            SKIP TO END
          </button>
        </div>
      </div>
    </>
  );
}

export default ReceiptWalletFront;
